import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { hasPerm } from './utils/permission'

Vue.use(ElementUI, { size: 'medium' })

// 全局权限判断方法：$hasPerm('course:add') / $hasPerm(['course:add','course:edit'])
Vue.prototype.$hasPerm = hasPerm
// 全局权限指令：<el-button v-permission="'course:add'">无权限时直接移除元素</el-button>
Vue.directive('permission', {
  inserted(el, binding) {
    if (!hasPerm(binding.value)) {
      if (el.parentNode) el.parentNode.removeChild(el)
    }
  }
})

Vue.config.productionTip = false

// 全局错误处理：捕获组件渲染 / 生命周期钩子 / 模板事件回调中抛出的未捕获异常
// err: 错误对象；vm: 出错的 Vue 实例；info: 错误来源信息（如 "render"、"created hook"）
Vue.config.errorHandler = function (err, vm, info) {
  console.error('[Global Error]', info, err)
}

// 全局警告处理：捕获 Vue 运行时警告（prop 类型不匹配、重复 key 等），仅开发环境生效
// msg: 警告文本；vm: 相关实例；trace: 组件调用链（从子到父）
Vue.config.warnHandler = function (msg, vm, trace) {
  console.warn('[Global Warn]', msg, trace)
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
